import { format } from 'date-fns';
import Dropdown from 'lib/Dropdown';

const MONTH_NAMES = Array.from({ length: 12 }, (_, i) => format(new Date(2024, i, 1), 'MMMM'));

type YearMonthFormProps = {
  date: Date;
  onChange: (date: Date) => void;
  fromMonth?: Date | null;
  toMonth?: Date | null;
  yearsBefore?: number;
  yearsAfter?: number;
};

const YearMonthForm: React.FC<YearMonthFormProps> = ({
  date,
  onChange,
  fromMonth,
  toMonth,
  yearsBefore = 10,
  yearsAfter = 10,
}) => {
  const months: { code: number; name: string }[] = [];
  let startMonth = 0;
  let endMonth = 11;
  const years: { code: number; name: number }[] = [];
  const currentDate = new Date();
  let startYear = currentDate.getFullYear() - yearsBefore;
  let endYear = currentDate.getFullYear() + yearsAfter;
  let selectedMonth = date.getMonth();
  let selectedYear = date.getFullYear();

  if (fromMonth && toMonth) {
    startYear = fromMonth.getFullYear();
    endYear = toMonth.getFullYear();
    if (fromMonth.getFullYear() === date.getFullYear() && toMonth.getFullYear() === date.getFullYear()) {
      startMonth = fromMonth.getMonth();
      endMonth = toMonth.getMonth();
    } else if (fromMonth.getFullYear() === date.getFullYear()) {
      startMonth = fromMonth.getMonth();
    } else if (toMonth.getFullYear() === date.getFullYear()) {
      endMonth = toMonth.getMonth();
    }
  } else if (fromMonth) {
    startYear = fromMonth.getFullYear();
    endYear = fromMonth.getFullYear() + yearsAfter;
    if (fromMonth.getFullYear() === date.getFullYear()) {
      startMonth = fromMonth.getMonth();
    }
  } else if (toMonth) {
    startYear = toMonth.getFullYear() - yearsBefore;
    endYear = toMonth.getFullYear();
    if (toMonth.getFullYear() === date.getFullYear()) {
      endMonth = toMonth.getMonth();
    }
  }

  for (let i = startYear; i <= endYear; i++) {
    years.push({ code: i, name: i });
  }

  for (let i = startMonth; i <= endMonth; i++) {
    months.push({ code: i, name: MONTH_NAMES[i] });
  }

  const handleChange = function handleChange(): void {
    onChange(new Date(selectedYear, selectedMonth));
  };

  const setMonthValue = (value: string): void => {
    selectedMonth = Number(value);
    handleChange();
  };

  const setYearValue = (value: string): void => {
    selectedYear = Number(value);
    handleChange();
  };

  return (
    <div className="dayPicker-input mx-auto">
      <div className="dayPicker-month">
        <Dropdown
          name="month"
          dataList={months}
          value={date.getMonth()}
          onChange={setMonthValue}
          textKey="name"
          valueKey="code"
        />
      </div>
      <div className="dayPicker-year">
        <Dropdown
          name="year"
          dataList={years}
          value={date.getFullYear()}
          onChange={setYearValue}
          textKey="name"
          valueKey="code"
        />
      </div>
    </div>
  );
};

export default YearMonthForm;
